export const AI_CHATBOT_STATUS = {
  ON: 'on',
  OFF: 'off',
};

export const PROMPT_TYPE = {
  HUMAN: 'human',
  AI: 'ai',
};

export const MAX_CHARACTERS_AMOUNT = 1000;

export const AI_LOADING_OPTIONS = { HISTORY: 'history', CHATBOT_ANSWER: 'chatbotAnswer' };
